import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogThreadCardSeenDropdownContent from './VeltCommentDialogThreadCardSeenDropdownContent/VeltCommentDialogThreadCardSeenDropdownContent';
import VeltCommentDialogThreadCardSeenDropdownTrigger from './VeltCommentDialogThreadCardSeenDropdownTrigger/VeltCommentDialogThreadCardSeenDropdownTrigger';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltCommentDialogThreadCardSeenDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardSeenDropdown.Trigger = VeltCommentDialogThreadCardSeenDropdownTrigger;
VeltCommentDialogThreadCardSeenDropdown.Content = VeltCommentDialogThreadCardSeenDropdownContent;
export default VeltCommentDialogThreadCardSeenDropdown;
